import { ArrowRight } from "lucide-react";
import { Link } from "react-router";
import { articles } from "../data/articles";

export function BlogPreview() {
  const latestBlogs = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-24 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 md:mb-12">
           <div className="mb-4 md:mb-0">
             <h2 className="text-3xl font-bold text-slate-900 mb-2">Latest Insights</h2>
             <p className="text-slate-600">Thoughts on technology, business, and design.</p>
           </div>
           <Link to="/articles" className="text-[#FD5750] font-semibold hover:underline hidden md:block">
             View all articles
           </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {latestBlogs.map((blog) => (
            <Link 
              to={`/articles/${blog.slug}`} 
              key={blog.id} 
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 group block"
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={blog.image} 
                  alt={blog.title} 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-xs font-bold text-[#FD5750] uppercase tracking-wider mb-2 block">{blog.category}</span>
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-[#FD5750] transition-colors">{blog.title}</h3>
                <p className="text-slate-600 text-sm mb-4 leading-relaxed line-clamp-3">{blog.excerpt}</p>
                <div className="flex items-center text-sm font-semibold text-slate-900 gap-2 group/link">
                  Read More <ArrowRight size={16} className="group-hover/link:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
        
        <div className="mt-8 text-center md:hidden">
           <Link to="/articles" className="text-[#FD5750] font-semibold hover:underline">
             View all articles
           </Link>
        </div>
      </div>
    </section>
  );
}
